export default __webpack_public_path__ + "static/media/avatar.394ada4d.jpg";